import React from 'react';
import {ProgressBarStepModel} from './model';
import {ProgressStepComponent} from './ProgressStepComponent';

interface InProgressStepProps extends ProgressBarStepModel {
  onClick?: () => void;
}

export const InProgressStep: React.FC<InProgressStepProps> = ({ id, onClick, disabled, selected }) => {
  return <ProgressStepComponent id={id} onClick={onClick} disabled={disabled} selected={selected} inProgress />;
};
